
// src/telemetry/NoopTelemetryProvider.jsx
import React, { createContext, useContext } from "react";

const NoopCtx = createContext({
  sessionId: undefined,
  track: () => {},      // no-op
  telemetry: null,      // no instance
});

export function NoopTelemetryProvider({ children }) {
  return (
    <NoopCtx.Provider value={{ sessionId: undefined, track: () => {}, telemetry: null }}>
      {children}
    </NoopCtx.Provider>
  );
}

export function useTelemetry() {
  return useContext(NoopCtx);
}
``
